/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { groupByFirstLetter } from 'my-phorest/utils/group-by-first-letter';
import { service } from '@ember/service';

export default class ClientsSearchGroupComponent extends Component {
  @service recentClients;
  @service intl;

  get groups() {
    let groups = groupByFirstLetter(this.args.clients);

    if (!this.args.hasSearchInput) {
      if (this.recentClients.hasItems()) {
        let recentlyInteractedWith = {
          name: this.intl.t('clients.search.recently-interacted-with'),
          items: this.recentClients.items,
        };
        groups = [recentlyInteractedWith, ...groups];
      }

      if (this.args.showWalkIn) {
        const walkIn = {
          name: this.intl.t('clients.search.guest'),
          items: [
            { name: this.intl.t('clients.search.walk-in'), isWalkIn: true },
          ],
        };
        groups = [walkIn, ...groups];
      }
    }

    return groups;
  }
}
